import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-arrow-top',
  templateUrl: './icon-arrow-top.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconArrowTopComponent {}
